import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

interface Question {
  questionId: number;
  questionText: string;
  questionType: 'single_choice' | 'multiple_choice';
  options: {
    optionId: number;
    optionText: string;
    isCorrect: boolean;
  }[];
}

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['./exam.component.scss']
})
export class ExamComponent implements OnInit {
  slides: any = [];
  blogs: any = [];
  bookCover: any;
  bannerImage: any;
  slideConfig = {
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    speed: 800,
    pauseOnHover: true,
    swipe: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }
  homeObj: any = {};
  siteUrl = environment.siteUrl;
  homePageVideoImage:any;
  homePageVideo:any;
  questionHomePage:any;
  constructor(private appService: AppService) {

  }

  ngOnInit(): void {
    this.appService.getBlogs().subscribe((res: any) => {
      this.blogs = res.filter((item:any)=>{
        return item['status'] == 'Active'
      }).sort((a: any, b: any) => {
        return new Date(b['createdAt']).getTime() - new Date(a['createdAt']).getTime();
      }).splice(0,4);
    });
    this.appService.getEvents().subscribe((res: any) => {
      this.slides = res.filter((item:any)=>{
        return item['status'] == 'Active'
      }).sort((a: any, b: any) => {
        return new Date(a['createdAt']).getTime() - new Date(b['createdAt']).getTime();
      }).splice(0,10);
    });
    this.homeObj = this.appService.getPageByKey('home');
    this.homePageVideoImage = this.appService.getPageByKey('homePageVideoImage');
    this.homePageVideo = this.appService.getPageByKey('homePageVideo');
    this.questionHomePage = this.appService.getPageByKey('questionHomePage');
    this.bookCover = this.appService.getPageByKey('book_cover_1')?.title;
    this.bannerImage = this.appService.getPageByKey('banner')?.title;
  }


  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit(e) {
    console.log('slick initialized');
  }

  breakpoint(e) {
    // console.log('breakpoint');
  }

  afterChange(e) {
    // console.log('afterChange');
  }

  beforeChange(e) {
    // console.log('beforeChange');
  }
}